import { render, staticRenderFns } from "./CallPlayer.vue?vue&type=template&id=70c0d58f&"
import script from "./CallPlayer.vue?vue&type=script&lang=ts&"
export * from "./CallPlayer.vue?vue&type=script&lang=ts&"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./CallPlayer.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/actions-runner/_work/mfe-ca-tester/mfe-ca-tester/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c0d58f')) {
      api.createRecord('70c0d58f', component.options)
    } else {
      api.reload('70c0d58f', component.options)
    }
    module.hot.accept("./CallPlayer.vue?vue&type=template&id=70c0d58f&", function () {
      api.rerender('70c0d58f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CallPlayer.vue"
export default component.exports